// Sao (KHÔNG dời) file sang `{path}.avatar-backup-{ISO ts}` — card #254, review L1.
//
// Khác `backupIfExists` (project-tree-scaffolder.ts) ở chỗ dùng COPY: file gốc nằm yên cho tới
// khi caller thay nó bằng ghi nguyên tử (tmp + rename). Ghi lỗi giữa chừng (ENOSPC…) thì bản gốc
// vẫn còn nguyên — với rename-trước-ghi, CLAUDE.md sẽ biến mất.
//
// `COPYFILE_EXCL` ⇒ không bao giờ đè backup cũ; trùng tên (2 lần trong cùng ms / bản sót lại)
// thì thêm hậu tố `-{n}` như `backupIfExists`.
import { constants, promises as fs } from "node:fs";
import { pathExists } from "./filesystem-helpers.js";

const MAX_NAME_ATTEMPTS = 6;

/** Trả đường backup, hoặc `null` khi file nguồn không tồn tại. */
export async function copyFileToAvatarBackup(path: string): Promise<string | null> {
  if (!(await pathExists(path))) return null;
  const basePath = `${path}.avatar-backup-${new Date().toISOString().replace(/[:.]/g, "-")}`;
  for (let attempt = 0; attempt < MAX_NAME_ATTEMPTS; attempt++) {
    const candidate = attempt === 0 ? basePath : `${basePath}-${attempt}`;
    try {
      await fs.copyFile(path, candidate, constants.COPYFILE_EXCL);
      return candidate;
    } catch (err) {
      if ((err as NodeJS.ErrnoException).code !== "EEXIST") throw err;
    }
  }
  throw new Error(`Could not find free backup name for ${path}`);
}
